import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { TargetDetail } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.targets.get` (frame c2). No read while no target is open. */
export function useTargetDetail(accountId: number, targetUuid: string | null) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.targets.get.queryOptions(
      { accountId, targetUuid: targetUuid ?? '' },
      { enabled: targetUuid !== null, retry: false }
    )
  );
  const retry = useRetry(query.refetch);
  return { detail: query.data as TargetDetail | undefined, isLoading: query.isLoading, error: query.error, retry };
}
